import { z } from 'src/lib'
import {
    EntityListWithPaginationFields,
    EntityPaginationFields,
    EntityWithIdAndDescriptionFields,
    EntityWithIdFields
} from './baseEntities'

import { SelectionOption } from 'src/lib/itaptec/components_forms/src'
import { ZodType } from 'zod'

// const a: SelectionOption = a.
// type a = keyof SelectionOption

export const schemaSelectionOption = z.object({
    value: z.number(),
    label: z.string()
}) satisfies ZodType<SelectionOption>

export const schemaEntityWithId = z.object({
    [EntityWithIdFields.Id]: z.number()
})

export const schemaEntityWithIdAndDescription = z
    .object({
        [EntityWithIdAndDescriptionFields.Description]: z.string()
    })
    .merge(schemaEntityWithId)

export const schemaEntityPagination = z.object({
    [EntityPaginationFields.ActualPage]: z.number(),
    [EntityPaginationFields.CantPages]: z.number(),
    [EntityPaginationFields.CantRecords]: z.number(),
    [EntityPaginationFields.PageSize]: z.number()
})

export const schemaEntityListWithPagination = <T extends z.ZodTypeAny>(schema: T) =>
    z.object({
        [EntityListWithPaginationFields.List]: z.array(schema),
        [EntityListWithPaginationFields.Pagination]: schemaEntityPagination
    })

type EntityListWithPaginationType<T extends z.ZodType> = ReturnType<typeof schemaEntityListWithPagination<T>> // no exportar

